import React from 'react';
import { FINAL_CTA, scrollToId } from '../../data/content';
import { LineRevealOnView, Reveal } from './Reveal';

export const FinalCTA = () => (
  <section className="py-12 md:py-16">
    <div className="max-w-[1500px] mx-auto px-6 md:px-12 text-center flex flex-col items-center">
      <Reveal>
        <span className="font-serif italic text-teal text-2xl md:text-3xl">
          {FINAL_CTA.emphasis}
        </span>
      </Reveal>

      <div className="mt-6 max-w-4xl">
        <LineRevealOnView
          lines={FINAL_CTA.lines}
          className="space-y-2"
          lineClassName="font-serif text-teal text-2xl sm:text-4xl lg:text-5xl leading-[1.15] tracking-[-0.005em]"
          stagger={0.12}
        />
      </div>

      <Reveal delay={0.2}>
        <button
          data-testid="join-cta"
          onClick={() => scrollToId('enter')}
          className="group relative mt-9 inline-flex items-center gap-3 bg-teal text-cream px-11 py-5 text-xs tracking-[0.24em] uppercase font-medium overflow-hidden"
        >
          <span className="relative z-10">{FINAL_CTA.cta}</span>
          <span className="relative z-10 transition-transform duration-500 group-hover:translate-x-1">
            &rarr;
          </span>
          <span className="absolute inset-0 bg-klein translate-y-full transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:translate-y-0" />
        </button>
      </Reveal>
    </div>
  </section>
);
